import { render, staticRenderFns } from "./PopupPeerRating.vue?vue&type=template&id=42af17b8"
import script from "./popup-peer-rating.ts?vue&type=script&lang=ts&external"
export * from "./popup-peer-rating.ts?vue&type=script&lang=ts&external"
import style0 from "./popup-peer-rating.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports